import React from "react";
import Button, {
  buttonVariants,
} from "@visiblethread/react-components/dist/components/Button";
import { showModal } from "slices/app/actions/modals";
import { modalTypes } from "constants/types";
import { useDispatch } from "react-redux";

const UsersCreate = () => {
  const dispatch = useDispatch();

  return (
    <div className="users__create__user">
      <span>New Users</span>
      <Button
        onClick={() => {
          dispatch(showModal(modalTypes.NEW_USER));
        }}
        variant={buttonVariants.primary}
        content={<span>Add New User</span>}
      />
      <Button
        onClick={() => {
          dispatch(showModal(modalTypes.IMPORT_USERS));
        }}
        variant={buttonVariants.secondary}
        content={<span>Import from CSV</span>}
      />
    </div>
  );
};

export default UsersCreate;
